import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const CuentaFormGroup = ({ iTouched, iError, fIsSubmitting }) => {
  const monedaArray = React.useMemo(() => {
    return ['SOLES', 'DOLARES']
  }, [])
  const selectOpions = React.useMemo(() => {
    const salida = []
    for (let i = 0; i < monedaArray.length; i++) {
      const element = monedaArray[i]
      salida.push(
        <option key={i} value={element}>
          {element}
        </option>
      )
    }
    return salida
  }, [monedaArray])

  return (
    <Form.Group>
      <Form.Label text={'Moneda'} md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='moneda'>
          {({ field }) => (
            <Form.Select {...field} id='select-moneda' isInvalid={iTouched && iError} disabled={fIsSubmitting}>
              {selectOpions}
            </Form.Select>
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaFormGroup)
